import { useMemo } from 'react';

interface UseInputTableActionsOptions {
  onAddRow: () => void;
  onCopyRow: () => void;
  onDeleteRow: () => void;
  onMoveRow: (direction: 'up' | 'down') => void;
  onPasteRow: (clipboardText?: string) => void | Promise<void>;
  onExport?: () => void;
  onPin?: () => void;
  onViewInventory?: () => void;
  onViewReceipt?: () => void;
}

const noop = () => undefined;

export function useInputTableActions({
  onAddRow,
  onCopyRow,
  onDeleteRow,
  onMoveRow,
  onPasteRow,
  onExport = noop,
  onPin = noop,
  onViewInventory = noop,
  onViewReceipt = noop
}: UseInputTableActionsOptions) {
  return useMemo(
    () => ({
      add: onAddRow,
      delete: onDeleteRow,
      copy: onCopyRow,
      paste: onPasteRow,
      moveUp: () => onMoveRow('up'),
      moveDown: () => onMoveRow('down'),
      export: onExport,
      pin: onPin,
      viewInventory: onViewInventory,
      viewReceipt: onViewReceipt
    }),
    [onAddRow, onCopyRow, onDeleteRow, onExport, onMoveRow, onPasteRow, onPin, onViewInventory, onViewReceipt]
  );
}
